// Route definitions
export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/auth/forgot-password',
  RESET_PASSWORD: '/auth/reset-password',
  CHANGE_PASSWORD: '/change-password',
  DASHBOARD: '/dashboard',
  TRANSACTIONS: '/transactions',
  INVENTORY: '/inventory',
  MERCHANT: '/merchant',
  MERCHANT_DASHBOARD: '/merchant/dashboard',
  MERCHANT_TRANSACTIONS: '/merchant/transactions',
  MERCHANT_WEBHOOKS: '/merchant/webhooks',
  MERCHANT_TEAMS: '/merchant/teams',
  WEBHOOK_DETAIL: '/merchant/webhooks/:webhookId',
  ACCOUNT_ACTIVATION: 'auth/account-activation/:token',
  ROUTING_RULES: '/merchant/teams',

  TEAM_USER: '/teamUser',
  TEAM_USER_DASHBOARD: '/teamUser/dashboard',
  TEAM_USER_TRANSACTIONS: '/teamUser/transactions',
  TEAM_USER_WEBHOOKS: '/teamUser/webhooks',
  TEAM_USER_TEAMS: '/teamUser/teams',
  TEAM_USER_DETAIL: '/teamUser/webhooks/:webhookId',



  PROFILE: '/profile',
  STORE: '/store',
  SETTINGS: '/settings',
  NOT_FOUND: '/404',
  UNAUTHORIZED: '/unauthorized',
} as const;

export type RouteKey = keyof typeof ROUTES;
export type RoutePath = (typeof ROUTES)[RouteKey];
